import { useState } from 'react';
import { useParams } from 'react-router';
import { InvestorsView } from '@/pages/admin/Investors/Main/View';
import { adminApi } from '@/api/admin';
import { useSelector } from 'react-redux';
import { usePopups } from '@/hooks';

export const Investors = () => {
  const { type } = useParams();
  const { showLoader, hideLoader, showInfoToast } = usePopups();
  const { investorsOnPage } = useSelector((state) => state.admin);

  const [investors, setInvestors] = useState([]);

  const fetchInvestors = (params = {}) => {
    showLoader('Fetching...');

    adminApi
      .getInvestors({
        take: investorsOnPage,
        reverse: true,
        account: type,
        ...params
      })
      .then((res) => {
        if (res.status === 200) {
          setInvestors(res.data);
        }
      })
      .finally(() => hideLoader())
      .catch((e) => {
        console.error(e);
        showInfoToast('Something went wrong');
      });
  };

  return (
    <InvestorsView
      investors={investors}
      fetchInvestors={fetchInvestors}
      INVESTORS_ON_PAGE={investorsOnPage}
      type={type}
    />
  );
};
